export enum MediaCollectionName {
    Horse = 'horse',
    Ride = 'ride',
    HorseHealth = 'horseHealth',
    HorseEvaluationMatrix = 'horseEvaluationMatrix',
    HorseCompetition = 'horseCompetition'
}
